import rehypeStringify from 'rehype-stringify';
import remarkBreaks from 'remark-breaks';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import { unified } from 'unified';
import PropTypes from 'prop-types';

export function markdown(input) {
    return String(
        unified()
            .use(remarkParse)
            // Turns newlines into <br>'s:
            .use(remarkBreaks)
            // Turns markdown into AST:
            .use(remarkRehype)
            // Turns AST into s string:
            .use(rehypeStringify)
            .processSync(input)
    );
}

export function Markdown({ children }) {
    return <span dangerouslySetInnerHTML={{ __html: markdown(children) }}></span>;
}

Markdown.propTypes = {
    children: PropTypes.string.isRequired,
};
